import { render, staticRenderFns } from "./AddKerjaPanas.vue?vue&type=template&id=1ef3e1cb&lang=pug&"
import script from "./AddKerjaPanas.vue?vue&type=script&lang=js&"
export * from "./AddKerjaPanas.vue?vue&type=script&lang=js&"
import style0 from "./AddKerjaPanas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports